<template>
  <b-col
    :cols="colSize * 6"
    :sm="colSize * 4"
    :md="colSize * 2"
    :lg="colSize * 2"
    :xl="colSize"
    v-bind="$attrs"
  >
    <b-form-group :class="isMultiple ? 'multiple-select' : ''" :label="label" :label-for="name" :label-cols="labelCols">
      <slot></slot>
      <multiselect
        :value="value"
        @input="inputHandler"
        @close="$emit('onChange')"
        @remove="$emit('onRemove', $event)"
        :options="optionsWithEmpty.map((opt) => opt.key)"
        :custom-label="(opt) => lab(opt)"
        :name="name"
        placeholder="..."
        select-label=""
        :multiple="isMultiple"
        selectedLabel=""
        class="multiselect-filter"
        :close-on-select="!isMultiple"
        deselectLabel=""
        :disabled="disabled"
      >
        <span slot="noResult">{{ $t('К сожалению поиск не дал результатов') }}.</span>
        <template v-if="isMultiple" slot="beforeList">
          <span v-if="value.length != options.length" class="select-all multiselect__element" @click="selectAll">Выделить все</span>
          <span v-if="value.length >= 1" class="select-all multiselect__element" @click="unSelectAll">Снять выделение</span>
        </template>
      </multiselect>
    </b-form-group>
  </b-col>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  name: 'filter-select',
  components: { Multiselect },
  props: [
    'value',
    'label',
    'options',
    'emptyAsNull',
    'name',
    'disabled',
    'cols',
    'multiple',
    'withoutEmpty',
    'labelCols',
  ],
  data: function() {
    return {
      optionsWithEmpty: [],
      isMultiple: false,
    };
  },
  mounted() {
    this.isMultiple = this.multiple || false;
  },
  methods: {
    lab: function(opt) {
      const option = this.optionsWithEmpty.find((x) => x.key == opt);
      return option ? option.value : '';
    },
    selectAll() {
      this.$emit('input', this.options.map(m => m.key));
    },
    unSelectAll() {
      this.$emit('input', []);
    },
    inputHandler(e) {
      if (e == -1) {
        e = null;
        if(this.emptyAsNull) {
          e = '';
        }
      }
      this.$emit('input', this.isMultiple ? e : e + '');
    },
  },
  computed: {
    colSize: function() {
      return this.cols || 3;
    },
  },
  watch: {
    optionsWithEmpty: function(val) {
      if (val && val.length > 0 && !val.find((x) => x.key == -1)) {
        if (!this.withoutEmpty) {
          this.optionsWithEmpty.unshift({ key: -1, value: '...' });
        }
      } else if (val && val.length == 0) {
        if (!this.withoutEmpty) {
          this.optionsWithEmpty = [{ key: -1, value: '...' }];
        }
      }
    },
    options: function(val) {
      this.optionsWithEmpty = val.slice();
    },
  },
};
</script>

<style lang="scss">
@import '../../../css/vue-multiselect-bootstrap.scss';

legend {
  font-weight: bold;
}
</style>
